module.exports = __webpack_public_path__ + "static/img/logo5.12cd5077.jpg";